import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * A real page for a wrong address.
 *
 * The router used to answer every unknown path with a silent redirect to the
 * landing page, which reads as a bug: you typed something, m3cull showed you a
 * marketing page, and never said why. Say what happened and offer the two
 * places worth going.
 */
export default function NotFound() {
  const navigate = useNavigate();

  return (
    <main
      id="main"
      className="mx-auto flex min-h-full w-full max-w-content flex-col justify-center px-5 py-24 sm:px-8"
    >
      <p className="label-mono">Error 404</p>

      <h1 className="mt-6 max-w-2xl text-mega font-semibold text-balance text-ink-50">
        There is nothing at this address.
      </h1>

      <p className="mt-6 max-w-md text-lead text-ink-400">
        The link is wrong, or the shoot it pointed at has been deleted. Your photographs are
        untouched either way: m3cull has never had a copy of them.
      </p>

      <div className="mt-10 flex flex-wrap items-center gap-3">
        <button className="btn-primary px-5 py-2.5 text-body" onClick={() => navigate('/')}>
          <ArrowLeft size={15} />
          Back to m3cull
        </button>
        <button className="btn-outline px-5 py-2.5 text-body" onClick={() => navigate('/shoots')}>
          See your shoots
        </button>
      </div>
    </main>
  );
}
